export const zh = {
  "header": {
    "brand": "CikaStudio",
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "nav": {
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "actions": {
    "copy": "复制",
    "download": "下载",
    "clear": "清空",
    "copied": "已复制!",
    "copyAll": "复制全部",
    "downloadTxt": "下载 TXT",
    "generate": "生成",
    "regenerate": "重新生成",
    "format": "格式化",
    "minify": "压缩",
    "validate": "验证",
    "convert": "转换"
  },
  "footer": {
    "privacy": "隐私",
    "terms": "条款",
    "email": "联系我们",
    "moreTools": "更多工具",
    "copyright": "© {year} CikaStudio. 保留所有权利。"
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "浅色",
    "dark": "深色"
  },
  "common": {
    "clientSide": "100% 客户端处理",
    "noUpload": "不上传数据",
    "noAccount": "无需账号",
    "loading": "加载中...",
    "error": "错误",
    "success": "成功"
  },
  "pdfMerge": {
    "title": "PDF 合并工具",
    "subtitle": "将多个 PDF 文件合并为一个。",
    "privacy": "100% 本地处理",
    "noUpload": "无需上传",
    "uploadTitle": "添加 PDF 文件",
    "uploadDesc": "拖拽或点击选择。拖拽可调整顺序。",
    "addFiles": "添加 PDF",
    "files": "文件",
    "pages": "页",
    "dragReorder": "拖拽调整顺序",
    "selectPdf": "请选择 PDF 文件",
    "invalidPdf": "无效或损坏的 PDF 文件",
    "minFiles": "请至少添加 2 个 PDF 文件进行合并",
    "minValid": "请至少添加 2 个有效的 PDF 文件",
    "merging": "正在合并...",
    "merged": "合并成功",
    "merge": "合并 PDF"
  },
  "content": {
    "privacy": {
      "title": "隐私与安全",
      "description": "🔒 所有 PDF 合并均在您的浏览器本地完成。您的文档绝不会被上传到任何服务器。"
    },
    "guide": {
      "title": "如何使用 PDF 合并工具",
      "description": "在浏览器中将多个 PDF 文件即时合并为一个文档。",
      "steps": [
        {
          "title": "上传 PDF 文件",
          "description": "拖放或点击选择多个 PDF 文件。该工具支持在设备内存限制内的任意数量的文件。"
        },
        {
          "title": "排列顺序",
          "description": "拖动文件以重新排序。合并后的 PDF 将按文件列表中从上到下的顺序排列。"
        },
        {
          "title": "下载合并后的 PDF",
          "description": "点击合并按钮将所有文件合并为一个 PDF。即时下载结果。原始文件不会被修改。"
        }
      ]
    },
    "features": {
      "title": "核心功能",
      "items": [
        "一次操作合并无限数量的 PDF 文件",
        "支持拖放文件排序",
        "保留原始页面内容和质量",
        "快速的客户端处理，无需上传等待",
        "即时下载合并后的文档",
        "100% 客户端处理 — 零数据上传"
      ]
    },
    "faq": {
      "title": "常见问题",
      "items": [
        {
          "question": "我的 PDF 会被发送到服务器吗？",
          "answer": "不会。所有合并均通过 PDF-Lib 库在您的浏览器本地完成。您的文档绝不会离开您的设备，因此适用于机密合同、报告和法律文件。"
        },
        {
          "question": "有文件大小或页数限制吗？",
          "answer": "没有严格限制，但非常大的 PDF 可能受浏览器内存限制。大多数设备可以轻松处理最大 50MB 和数百页的文件。"
        },
        {
          "question": "书签和元数据会被保留吗？",
          "answer": "合并工具保留所有页面内容、图片和文字。一些高级 PDF 功能（如交互式表单和 JavaScript）可能在合并过程中被简化。"
        }
      ]
    },
    "related": {
      "title": "相关工具",
      "tools": [
        {
          "name": "图片转换器",
          "url": "/image/image-converter",
          "description": "在浏览器中即时转换 JPG、PNG 和 WebP 格式。"
        },
        {
          "name": "图片水印工具",
          "url": "/image/image-watermarker",
          "description": "为图片添加文本或 logo 水印，支持批量处理。"
        },
        {
          "name": "Base64 转换器",
          "url": "/converter/base64",
          "description": "快速安全地编码和解码 Base64 字符串。"
        }
      ]
    }
  }
};
